import { Facebook, Instagram, Youtube, MessageCircle } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const pages = [
  { href: "/politica-de-privacidade", label: "Política de Privacidade" },
  { href: "/politica-de-cookies", label: "Política de Cookies" },
  { href: "/termos-de-uso", label: "Termos de Uso" },
  { href: "/contato", label: "Contato" },
];

const socials = [
  {
    href: "https://www.facebook.com/rodrigohaertel",
    label: "Facebook",
    Icon: Facebook,
  },
  {
    href: "https://www.instagram.com/rodrigohaertel",
    label: "Instagram",
    Icon: Instagram,
  },
  {
    href: "https://www.youtube.com/rodrigohaertel",
    label: "YouTube",
    Icon: Youtube,
  },
  {
    href: "https://wa.me/5547992190500",
    label: "WhatsApp",
    Icon: MessageCircle,
  },
];

const Footer = () => {
  const year = new Date().getFullYear();
  const { pathname } = useLocation();

  const renderLink = (p: { href: string; label: string }) => {
    const isInternal = p.href.startsWith("/");
    const isActive = isInternal && pathname === p.href;
    const baseClasses = isActive
      ? "text-accent"
      : "text-muted-foreground transition-colors hover:text-foreground";

    if (isInternal) {
      return (
        <Link to={p.href} className={baseClasses} aria-current={isActive ? "page" : undefined}>
          {p.label}
        </Link>
      );
    }
    return (
      <a href={p.href} className={baseClasses}>
        {p.label}
      </a>
    );
  };

  return (
    <footer className="border-t border-border/60 bg-background-warm px-6 py-12 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-10 text-center md:grid-cols-[1.5fr_1fr_1fr] md:gap-12 md:text-left">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start">
            <Link
              to="/"
              className="font-serif text-2xl tracking-tight text-foreground"
            >
              Rodrigo<span className="text-accent">.</span>Haertel
            </Link>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-muted-foreground md:max-w-sm">
              Consultor empresarial, mentor de negócios e metodologista do
              Empretec. Atuação em todo o Brasil.
            </p>
            <p className="mt-3 text-xs uppercase tracking-[0.18em] text-muted-foreground/80">
              CRA/SC 26456
            </p>
          </div>

          {/* Páginas */}
          <div>
            <h3 className="mb-4 text-xs font-medium uppercase tracking-[0.22em] text-accent">
              Institucional
            </h3>
            <ul className="space-y-2.5 text-sm md:space-y-3">
              {pages.map((p) => (
                <li key={p.label}>{renderLink(p)}</li>
              ))}
            </ul>
          </div>

          {/* Redes sociais */}
          <div>
            <h3 className="mb-4 text-xs font-medium uppercase tracking-[0.22em] text-accent">
              Redes sociais
            </h3>
            <div className="flex items-center justify-center gap-3 md:justify-start">
              {socials.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(href, "_blank", "noopener,noreferrer");
                  }}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-border/70 text-muted-foreground transition-all hover:border-accent/60 hover:text-accent"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-2 border-t border-border/60 pt-6 text-center text-xs text-muted-foreground/70 md:mt-14 md:flex-row md:items-center md:pt-8 md:text-left">
          <p>© {year} — Todos os direitos reservados.</p>
          <p>Plano A Mentoria LTDA. CNPJ: 18.836.944/0001-69</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
